import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../../i18n/locales/en/translation.json';
import de from '../../i18n/locales/de/translation.json';
import fr from '../../i18n/locales/fr/translation.json';
import es from '../../i18n/locales/es/translation.json';
import it from '../../i18n/locales/it/translation.json';
import hu from '../../i18n/locales/hu/translation.json';
import nl from '../../i18n/locales/nl/translation.json';

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
      hu: { translation: hu },
      nl: { translation: nl }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;



















